import { render } from "./ImageGroupDetails.vue?vue&type=template&id=9d23eff2&scoped=true"
import script from "./ImageGroupDetails.vue?vue&type=script&lang=ts"
export * from "./ImageGroupDetails.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-9d23eff2"

export default script